import React, { useEffect, useState, useRef } from "react";
import { Stack, Button, Box, Divider } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";

import { LoadingButton } from "@mui/lab";
import {
  CompleteAadhaarAPICall,
  KRAUpdateAPICall,
  digiLockerInitAPICall,
  digiLockerStatusAPICall,
  stageDetailsAPICall,
  startOverAPICall,
} from "../shared/APICalls";
import JsonDataToAadhaarFormat from "../Components/JsonDataToAadhaarFormat/JsonDataToAadhaarFormat";
import routesData from "../shared/routes.json";
import AadhaarStyles from "../pages/Styles/AadharKYC.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import KRAScreen from "./KRAscreen";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/aadharicongrey.svg";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";

export default function AadhaarKYCPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [kraFetched, SetKraFetched] = useState<any>(false);

  const [aadhaarData, setaadhaarData] = useState<any>();
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [closetTimer, setclosetTimer] = useState(false);
  const [loading, setloading] = useState(false);
  const [startOverloading, setstartOverloading] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [displayAadhaarData, setDisplayAadhaarData] = useState(false);
  const [backdropLoading, setbackdropLoading] = useState(false);

  const [KraData, setKraData] = useState<any>();
  const navigationData = routesData;
  const [navigatePath, setNavigate] = useState<any>();
  const [message, setMessage] = useState("");

  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");

  const timerRef = useRef<any>(null);

  const handleOpenClick = () => {
    setloading(true);
    let digilink: string = "";

    let obj: any = {
      digi_redirect_type: "ekyc_aadhaar",
    };
    digiLockerInitAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // setloading(false);
        // console.log("responseData", responseData);
        digilink = responseData.data.link;

        window.location.href = digilink;
        //  console.log("digilink", digilink);
        // setTimeout(() => {
        //   const childWindow: any = window.open(
        //     digilink,
        //     "_blank",
        //     "width=500,height=700"
        //   );
        //   setchildWindowRef(childWindow);
        // });

        // setloading(false);
        // if (
        //   responseData.data.stage &&
        //   navigationData.hasOwnProperty(responseData.data.stage)
        // ) {
        //   navigate(navigationData[responseData.data.stage]);
        // }
      })
      .catch((error: any) => {
        setloading(false);
      });
  };
  const handleClose = () => {
    setloading(false);
    setTimeout(() => {
      // navigate("/tradingPreference");
      navigate(navigatePath);
    }, 500);
  };

  const handleContinuetoNextPage = () => {
    let obj = {
      is_continued: true,
    };
    KRAUpdateAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        //  console.log("responseData", responseData.data.stage);
        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error.response.data.message);
      });
    setloading(false);
  };

  const handleContinue = () => {
    digiLockerStatusAPICall()
      .then((response: any) => {
        const responseData = response.data;

        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
        // console.log("responseData", responseData.data.stage);
      })
      .catch((error: any) => {
        // console.log("error", error.response.data.message);
      });
    setloading(false);
  };

  useEffect(() => {
    if (!closetTimer && childWindowRef) {
      //  console.log("timer trigger");
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef, closetTimer]);

  function checkChild() {
    // console.log("timer");
    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);
      // console.log("Child window closed");

      digiLockerStatusAPICall()
        .then((response: any) => {
          const responseData = response.data;

          // console.log("responseDatachild", responseData);

          StageDetails();

          // setDisplayAadhaarData(true);
          // setloading(false);

          setclosetTimer(true);
        })
        .catch((error: any) => {
          // console.log("error", error.response.data.message);
          setloading(false);
          setMessage(error.response.data.message);
          setshowModal(false);

          setTimeout(() => {
            setMessage("");
          }, 8000);
        });
    }
  }

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                //console.log("responseData", response);
                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    StageDetails();
  }, []);

  const StageDetails = () => {
    let obj: any = {
      stage: "kra_or_aadhaar",
    };
    setbackdropLoading(true);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        setbackdropLoading(false);
        const responseData = response.data.data;

        dispatch(setCompletedStages(responseData.completed_stages));
        dispatch(setCurrentStage(responseData.current_stage));
        if (responseData.ErrorMessage) {
          setRejectMessage(responseData.ErrorMessage);
        }

        if (responseData.data.is_kra_fetched) {
          setKraData(responseData.data.kra);
          SetKraFetched(true);
        }

        if (responseData.data.is_aadhaar_fetched) {
          setDisplayAadhaarData(true);
          SetKraFetched(false);
          if (responseData.data.aadhaar) {
            setaadhaarData(responseData.data.aadhaar);
          }
        }
      })
      .catch((error: any) => {
        setbackdropLoading(false);
        // console.log("error", error);
      });
  };

  const handleUpdateAadhaarClick = () => {
    SetKraFetched(false);
  };

  const CompleteAadhaarStage = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitAadhaar",
      },
    });

    CompleteAadhaarAPICall()
      .then((response: any) => {
        // console.log("response", response.data.data.next_stage);
        if (
          response.data.data.next_stage &&
          navigationData.hasOwnProperty(response.data.data.next_stage)
        ) {
          navigate(navigationData[response.data.data.next_stage]);
        }
      })
      .catch((error: any) => {});
  };

  // console.log("displayAadhaarData", displayAadhaarData);

  return (
    <>
      {/* <div className={AadhaarStyles.step}>
        <img src={keyboardicon} /> Step 1 of 4
      </div> */}
      <ProgressComp />
      <div className={AadhaarStyles.mainWrapper}>
        {backdropLoading && (
          <div style={{ height: "100vh", position: "absolute" }}>
            <BackDrop />
          </div>
        )}
        <ErrorSnackBar message={rejectMessage} />

        <div className={AadhaarStyles.wrapper}>
          {/* <div className={AadhaarStyles.step}>
            <img src={keyboardicon} /> Step 2 of 10
          </div> */}
          {!kraFetched ? (
            <>
              {!aadhaarData ? (
                <>
                  <div className={AadhaarStyles.titleSection}>
                    <p className={AadhaarStyles.title}>
                      {" "}
                      Aadhaar KYC Verification{" "}
                    </p>
                  </div>
                  <div className={AadhaarStyles.leftcontainer}>
                    <p className={AadhaarStyles.leftcontainerText}>
                      Use your Digilocker account to provide address information
                      for KYC. Your Aadhaar details will not be stored.
                    </p>
                  </div>
                  <div className={AadhaarStyles.startovernewsection}>
                    The Aadhaar and PAN must belong to you. If not,{" "}
                    <span
                      onClick={handleStartOver}
                      style={{
                        fontWeight: 500,
                        cursor: "pointer",
                        color: "#111827",
                      }}
                    >
                      Start Over
                    </span>
                  </div>
                  <div className={AadhaarStyles.buttonStyles}>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        className={AadhaarStyles.buttonKYC}
                        onClick={handleOpenClick}
                        loading={loading}
                        id="aadharOpenLinkButton2"
                        // sx={{ height: "50px" }}
                      >
                        Link From Digilocker
                      </LoadingButton>
                    </div>

                    <div>{backdrop && <StartOverBackDrop />}</div>
                  </div>
                  <div className={AadhaarStyles.bottomContentContainer}>
                    <p className={AadhaarStyles.bottomContent}>
                      *By clicking the above button. I agree that I have read
                      the{" "}
                      <a
                        href="https://uidai.gov.in/images/resource/Final_Aadhaar_Notice_and_Consent_Guidelines.pdf"
                        target="_blank"
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        Aadhaar user consent document
                      </a>{" "}
                      and voluntarily consent to share my Aadhaar information
                      (excluding the Aadhaar number) with Firstock for
                      conducting online KYC for opening a trading and Demat
                      account adhering to{" "}
                      <a
                        href="https://www.sebi.gov.in/legal/regulations/aug-2023/securities-and-exchange-board-of-india-kyc-know-your-client-registration-agency-regulations-2011-last-amended-on-august-18-2023-_76337.html"
                        target="_blank"
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        KRA regulation (2011)
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://fiuindia.gov.in/files/AML_Legislation/pmla_2002.html"
                        target="_blank"
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        PMLA guidlines (2002)
                      </a>
                      .
                    </p>
                  </div>
                </>
              ) : (
                <div className={AadhaarStyles.aadhaarDisplayContainer}>
                  <JsonDataToAadhaarFormat aadhaarData={aadhaarData} />
                  <div className={AadhaarStyles.buttonStylesFetched}>
                    {/* {rejectMessage && ( */}
                    <LoadingButton
                      type="submit"
                      variant="outlined"
                      className={AadhaarStyles.buttonKYCBottom}
                      onClick={handleOpenClick}
                      loading={loading}
                      id="aadharOpenLinkButton2"
                      sx={{
                        height: "50px",
                        color: "inherit",
                        background: "#fff",
                        border: "1px solid #E5E7EB",
                      }}
                    >
                      Redo
                    </LoadingButton>
                    {/* )} */}
                    <Button
                      id="aadhaarApproveButton1"
                      variant="contained"
                      onClick={CompleteAadhaarStage}
                      className={AadhaarStyles.approveButton}
                      sx={{ height: { xs: "60px", sm: "50px" } }}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className={AadhaarStyles.fetchWrapper}>
              <KRAScreen aadhaarData={KraData} />
              <div className={AadhaarStyles.fetchButtons}>
                <Button
                  id="continue2"
                  variant="outlined"
                  className={AadhaarStyles.fetchUpdate}
                  onClick={handleUpdateAadhaarClick}
                  sx={{ height: "50px", color: "#1F2937" }}
                >
                  Update as on Aadhaar
                </Button>
                <Button
                  id="continue1"
                  variant="contained"
                  className={AadhaarStyles.fetchContinue}
                  onClick={CompleteAadhaarStage}
                  sx={{ height: "50px" }}
                >
                  Continue
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
